import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<PollEvaluation @poll={{@model}} />",{ moduleName: "@croodle/client/templates/poll/evaluation.hbs" })